import React, { useState, useEffect } from 'react';
import { BringzzButton, BringzzText } from "@bringzz/components";
import { useNavigation } from 'context/NavigationContext';
import { BringzzPageContainer, BringzzPinCode, BringzzIcon } from "@bringzz/components";
import { useLocation } from 'react-router-dom';
import useRequest from 'hooks/useRequest';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

function useQuery() {
	return new URLSearchParams(useLocation().search);
}

const RegisterOTPpage = () => {
	const { backPress } = useNavigation();
	const { sendRequest, data, error, loading } = useRequest();
	const { navigate } = useNavigation();
	const { t } = useTranslation();

	const [isValid, setIsValid] = useState(false)
	const [resendTimer, setResendTimer] = useState(0);
	const [canResend, setCanResend] = useState(true);

	let query = useQuery();
	let redirect = query.get('redirect');
	let method = query.get('method');
	let methodValue = query.get('value');
	const userId = query.get('userId');

	useEffect(() => {
		if (resendTimer > 0) {
			const timer = setTimeout(() => {
				setResendTimer(resendTimer - 1);
			}, 1000);
			return () => clearTimeout(timer);
		} else if (resendTimer === 0) {
			setCanResend(true);
		}
	}, [resendTimer]);

	const validatePin = async (pin) => {
		return await sendRequest({
			method: 'POST',
			url: `/module/user/validateRegistrationToken`,
			data: {
				userId,
				token: pin,
			}
		})
			.then(response => {
				if (response.status === 'success') {
					return true
				};
			})
			.catch(error => {
				console.error(error);
				return false;
			});
	};

	const resendCode = async () => {
		if (!canResend) return;
		
		setCanResend(false);
		setResendTimer(30);
		
		return await sendRequest({
			method: 'POST',
			url: `/module/token/recreateValidation`,
			data: {
				userId,
				// loginType: 0,
				language: "en",
				// login: methodValue
			}
		})
			.then(response => {
				if (response.status === 'success') {
					toast.success(t('component.auth.register.otp.resend.success') || 'New code has been sent successfully!');
					return true
				};
			})
			.catch(error => {
				console.error(error);
				toast.error(t('component.auth.register.otp.resend.error') || 'Failed to resend code. Please try again.');
				setCanResend(true);
				setResendTimer(0);
				return false;
			});
	}

	const title = (
		<div className='flex flex-col'>
			<div>{t('component.auth.register.otp.title.verify_your')}</div>
			<div>{t(`component.auth.register.method_labels.${method}`)}</div>
		</div>
	);

	return (
		<BringzzPageContainer
			className='bg-white'

			header={{
				left: (
					<BringzzIcon
						size='22'
						icon='IconClose'
						folder='LineIcons'
						className='cursor-pointer'
						onClick={backPress}
					/>
				),
				title: t('component.auth.register.otp.header.confirmation')
			}}
			authenticated={false}
			footer={
				<div className='pb-8 px-6'>
					<BringzzButton
						size='lg'
						className='bg-magic-lilac w-full flex justify-center text-midnight-blue'
						onClick={() => {
							navigate(`${redirect}?method=${method}&userId=${userId}&value=${methodValue}`);
						}}
						disabled={!isValid}
					>
						{t('component.auth.register.otp.buttons.confirm')}
					</BringzzButton>
				</div>
			}
		>
			<div className='relative flex justify-center bg-magic-lilac/20'>
				<div className='relative bg-white w-full bg-cover bg-center flex flex-col md:max-w-2xl '>
					{/* Content */}
					<div className='flex-grow flex flex-col justify-between py-12 px-4'>
						{/* Bottom part */}
						<div className='z-10 flex flex-col '>
							<div className='flex flex-col space-y-6 mx-2 md:max-w-lg lg:max-w-xl xl:max-w-2xl'>
								<BringzzText tag='h1' className='pl-2 text-midnight-blue font-bold'>
									{title}
								</BringzzText>
								<BringzzText tag="h3" className="font-normal">
					{t('component.auth.register.otp.description.sent_message', {
						message_type: method === "email" ? t('component.auth.register.otp.description.email') : t('component.auth.register.otp.description.text_message')
					})}
				</BringzzText>
							</div>
							<div className='flex justify-center items-center mt-6'>
								<BringzzPinCode
									length={4}
									onChange={pin => console.log('pin change: ', pin)}
									onValidate={async pin => {
										return validatePin(pin);
									}}
									onSuccess={() => {
										setIsValid(true)
									}}
									onError={() => {
										toast.error(t('component.auth.register.otp.errors.invalid_code_try_again'));
										console.log('Error');
									}}
									upperChildContent={
										<div className='text-center py-4'>
											<BringzzText tag="h3" className="font-normal" >
												{t('component.auth.register.otp.description.enter_code')} <br />
											</BringzzText>
											<BringzzText ag="h3" className="font-bold">
												{
													method == "email" ? (
														methodValue
													) : (
														<>
															+***-***-
															{methodValue.substring(
																methodValue.length - 3,
																methodValue.length
															)}
														</>
													)
												}
											</BringzzText>
										</div>
									}
									lowerChildContent={
										<div>
											{!isValid && <div className='flex justify-center align-center mt-6 space-x-2'>
												<BringzzText tag="h3" className="font-normal">{t('component.auth.register.otp.resend.no_code')} </BringzzText>
												<div>&bull;</div>
												{canResend ? (
													<div onClick={resendCode}>
														<BringzzText tag="h3" className="cursor-pointer underline font-bold text-midnight-blue">{t('component.auth.register.otp.resend.button')}</BringzzText>
													</div>
												) : (
													<BringzzText tag="h3" className="text-gray-400">
														{t('component.auth.register.otp.resend.wait', { seconds: resendTimer }) || `Resend in ${resendTimer}s`}
													</BringzzText>
												)}
											</div>}
										</div>
									}
									spacing='space-x-2'
									disabled={loading || isValid}
									className={loading ? 'opacity-25' : ''}
								></BringzzPinCode>
							</div>
						</div>
					</div>
				</div>
			</div>
		</BringzzPageContainer>
	);
};

export default RegisterOTPpage;
